import { render, staticRenderFns } from "./BulkOperationsMatchDetailsWithEntityType.vue?vue&type=template&id=2e57f499&scoped=true"
import script from "./BulkOperationsMatchDetailsWithEntityType.vue?vue&type=script&lang=ts"
export * from "./BulkOperationsMatchDetailsWithEntityType.vue?vue&type=script&lang=ts"
import style0 from "./BulkOperationsMatchDetailsWithEntityType.vue?vue&type=style&index=0&id=2e57f499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e57f499",
  null
  
)

export default component.exports